import { ENV_NAME, getEnvironment } from '@heidi/api/config';

export const getRewardfulReferral = () => {
  const shouldUseRewardful = getEnvironment() === ENV_NAME.PROD;
  const referralId = shouldUseRewardful
    ? (window.Rewardful && window.Rewardful.referral) || undefined
    : undefined;
  const couponId = shouldUseRewardful
    ? (window.Rewardful && window.Rewardful.coupon?.id) || undefined
    : undefined;

  return { referralId, couponId };
};

declare global {
  // Define a more specific type for functions in the cmd array
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  type CelloCommandFunction = (...args: any[]) => void;

  // Update the CelloConfig interface
  interface CelloConfig {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    boot: (config: any) => void;
  }
  interface Window {
    Rewardful: {
      referral: string;
      coupon: {
        id: string;
      };
    };

    cello: CelloConfig & { cmd: Array<CelloCommandFunction> };
  }
}
